export type LeaveAccumulationUnit = "days" | "hours";

export interface LeaveAccumulationConfig {
  stateName: string;
  unit: LeaveAccumulationUnit;
  labelKey: string;
}

export const LEAVE_ACCUMULATION_MAP: Record<string, LeaveAccumulationConfig> = {
  ANNUAL_HOLIDAY: {
    stateName: "vuosiloma",
    unit: "days",
    labelKey: "annualLeft",
  },
  LEVELLING_LEAVE: {
    stateName: "työajanlyhennys",
    unit: "hours",
    labelKey: "levellingLeaveLeft",
  },
  ANNUAL_LEAVE: {
    stateName: "vuosivapaa",
    unit: "days",
    labelKey: "annualLeaveLeft",
  },
  MIDWEEK_LEAVE: {
    stateName: "ap-vapaa",
    unit: "hours",
    labelKey: "midweekLeaveLeft",
  },
  WORKTIME_BANK_LEAVE: {
    stateName: "tyoaikapankki",
    unit: "hours",
    labelKey: "worktimeBankLeft",
  },
};

export const CONTINUOUS_EMPLOYMENT_STATE_NAMES = new Set([
  "vuosivapaa",
  "ap-vapaa",
]);
